
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionHistoryAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userOrderStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderStatus"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userOrderTransactionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderTransactionType"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionHistoryFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionHistoryFilter"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_history_filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionHistoryFilter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userOrderStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userOrderStatus"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userOrderTransactionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userOrderTransactionType"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOrderReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FracPackReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FracPackReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DropReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CirclePaymentReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CirclePaymentReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CircleWithdrawalReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleWithdrawalReceipt"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1210}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/TransactionHistory/UserOrderReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/FracPackReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/DropReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/CirclePaymentReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/CircleWithdrawalReceipt.gql\"\n\nquery TransactionHistoryAll(\n  $offset: Int\n  $count: Int\n  $userOrderStatus: UserOrderStatus\n  $userOrderTransactionType: UserOrderTransactionType\n  $transactionHistoryFilter: TransactionHistoryFilter\n) {\n  current_user {\n    transaction_history(\n      filter: {\n        offset: $offset\n        count: $count\n        transaction_history_filter: $transactionHistoryFilter\n        userOrderStatus: $userOrderStatus\n        userOrderTransactionType: $userOrderTransactionType\n      }\n    ) {\n      ... on UserOrderReceipt {\n        ... UserOrderReceipt\n      }\n\t\t\t... on FracPackReceipt {\n        ... FracPackReceipt\n      }\n      ... on DropReceipt {\n        ... DropReceipt\n      }\n      ... on CirclePaymentReceipt {\n        ... CirclePaymentReceipt\n      }\n      ... on CircleWithdrawalReceipt {\n        ... CircleWithdrawalReceipt\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/UserOrderReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/FracPackReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/DropReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/CirclePaymentReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/CircleWithdrawalReceipt.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["TransactionHistoryAll"] = oneQuery(doc, "TransactionHistoryAll");
        
